(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elephant-floating"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const useCircle = JSON.parse(document.getElementById('use_circle').textContent.trim());
  if (useCircle) {
    const wrapper = document.getElementById('elephant-fixed-wrapper');
    const svg = wrapper.querySelector('#elephant-svg svg');
    const closeBtn = wrapper.querySelector('.close-elephant-circle-filter');

    function toggleFilter() {
      wrapper.classList.toggle('visible-filter');
    }

    svg.addEventListener('click', toggleFilter);
    closeBtn.addEventListener('click', toggleFilter);

    // Ensure compatibility with Prestige’s filter updates
    const sortSelect = document.getElementById('SortBy');
    sortSelect.addEventListener('change', function() {
      this.form.requestSubmit(); // Trigger form submission for sorting
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ljv-storefinder"] && !Shopify.designMode) return;
  try {
    
  function initMap() {
   // Create the map.
    const map = new google.maps.Map(document.getElementById('map'), {
        zoom: 7,
        center: { lat: 52.632469, lng: -1.689423 },
    });
  }

  } catch(e) { console.error(e); }
})();
})();
